import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Table,
  Form,
  Button,
  Card,
} from "react-bootstrap";
import { FaTrash, FaEdit, FaEye, FaPlus, FaComments, FaUpload, FaTasks } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import axios from "axios";

const Task = () => {
  const [taskList, setTaskList] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [processing, setProcessing] = useState("");
  const [pending, setPending] = useState("");
  const [completed, setCompleted] = useState("");

  const [defaultPending, setDefaultPending] = useState(0);
const [defaultProcessing, setDefaultProcessing] = useState(0);
const [defaultCompleted, setDefaultCompleted] = useState(0);

  const parseDateDMY = (value) => {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
    const sep = value.includes("-") ? "-" : value.includes("/") ? "/" : null;
    if (sep) {
      const parts = value.split(sep);
      if (parts.length === 3 && parts[2].length === 4) {
        const d = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10) - 1;
        const y = parseInt(parts[2], 10);
        const dt = new Date(y, m, d);
        return isNaN(dt) ? null : dt;
      }
    }
    const dt = new Date(value);
    return isNaN(dt) ? null : dt;
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}task_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          // setTaskList(response.data.body);
          setTaskList(response.data.body);
          setFilteredTaskList(response.data.body);
          // setFilteredOrders(response.data.body);
          setCompleted(response.data.body[0].total_complete_task);
          setProcessing(response.data.body[0].total_assigned_task);
          setPending(response.data.body[0].total_progress_task);

          setDefaultCompleted(response.data.body[0].total_complete_task);
setDefaultProcessing(response.data.body[0].total_assigned_task);
setDefaultPending(response.data.body[0].total_progress_task);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setTaskList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setTaskList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const [search, setSearch] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [filteredTaskList, setFilteredTaskList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customerList, setCustomers] = useState([]);

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  // const handleDelete = (id) => {
  //   setTaskList(taskList.filter((task) => task.id !== id));
  // };
  const handleDelete = (task_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}task_delete.php`, { task_id: task_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  // filter logic: search across several fields + optional date range on dueDate
  const filteredTasks = taskList.filter((task) => {
    const q = search.trim().toLowerCase();

    const matchesSearch =
      !q ||
      String(task.task_id).includes(q) ||
      (task.task_name && task.task_name.toLowerCase().includes(q)) ||
      (task.description && task.description.toLowerCase().includes(q)) ||
      (task.priority && task.priority.toLowerCase().includes(q)) ||
      (task.status && task.status.toLowerCase().includes(q)) ||
      (task.assigned_to_name && task.assigned_to_name.toLowerCase().includes(q)) ||
      (task.assigned_by_name && task.assigned_by_name.toLowerCase().includes(q)) ||
      (task.due_date && task.due_date.toLowerCase().includes(q)) ||
      (task.created_at && task.created_at.toLowerCase().includes(q)) ||
      (task.updated_at && task.updated_at.toLowerCase().includes(q));

    if (!matchesSearch) return false;


    if (fromDate || toDate) {
      const reqDate = parseDateDMY(task.due_date);
      if (!reqDate) return false;
      if (fromDate) {
        const from = new Date(fromDate + "T00:00:00");
        if (reqDate < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate + "T23:59:59");
        if (reqDate > to) return false;
      }
    }

    return true;
  });

  // Pagination over filtered results
  const {
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    indexOfFirstItem,
  } = usePagination(filteredTaskList, 25);

  const handleSubmit = () => {

    // Summary Cards
    axios.post(`${API_BASE_URL}task_count.php`, {
      user_id: selectedUser,
    })
      .then((response) => {
        if (response.data.head.code === 200) {
          setCompleted(response.data.body.total_complete_task);
          setProcessing(response.data.body.total_assigned_task);
          setPending(response.data.body.total_progress_task);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });

    // Table Filter
    if (selectedUser === "") {
      setFilteredTaskList(taskList);
    } else {
      const filtered = taskList.filter(
        (task) =>
          String(task.assigned_to) === String(selectedUser)
      );

      setFilteredTaskList(filtered);
    }
  };

  return (
    <Container fluid className="my-4 outer-container">
      <h2 className="text-center">Task Management</h2>
      {/* {currentItems.length === 0 && (
        <Container fluid className="outer-container my-4">
          <Row>
            <Col>
              <div className="not-found-box">Loading...</div>
            </Col>
          </Row>
        </Container>
      )} */}
      <Row className="mb-3">
        <Col md={12}>
          <div className="d-flex justify-content-end">
            <Link to="/addtask" className="btn-top">
              <FaPlus /> Add Task
            </Link>
            <div style={{ width: "10px" }}> </div>
            <Link
              to="/importtask"
              className="btn-top d-inline-flex align-items-center"
            >
              <FaUpload className="me-2" /> Import Tasks
            </Link>
          </div>
        </Col>
      </Row>

      {/* Filters row styled like PermissionLeaveList */}
      <Row className="mb-3">
        <Col md={4} className="mb-2">
          {/* <Form.Label>Search</Form.Label>
          <Form.Control
            placeholder="Search by title, priority, status, assignee..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          /> */}
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Select
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              className="custom-select-arrow"
            >
              <option value="">Select Name</option>

              {customerList.map((user) => (
                <option key={user.user_id} value={user.user_id}>
                  {user.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={1} className="d-flex mt-4">
          <Button
            className="btn-top"
            onClick={() => {
              console.log("=============== ", search);
              handleSubmit();
            }}
          >
            Search
          </Button>


        </Col>
        <Col md={1} className="d-flex mt-4">

          <Button
           className="btn-top"
            variant="secondary"
            onClick={() => {
              setSelectedUser("");
              setFilteredTaskList(taskList);

               // Reset summary cards
    setPending(defaultPending);
    setProcessing(defaultProcessing);
    setCompleted(defaultCompleted);
            }}
          >
            Clear
          </Button>
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>From</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            placeholder="From Date"
          />
        </Col>



        <Col md={3} className="mb-2">
          <Form.Label>To</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            placeholder="To Date"
          />
        </Col>

        {/* <Col md={2} className="d-flex mt-4">
          <Button
            className="btn-top"
            onClick={() => {
              setSearch("");
              setFromDate("");
              setToDate("");
            }}
          >
            Clear Filters
          </Button>
        </Col> */}
      </Row>


      <Row className="g-3">
        <Col md={4}>
          <Card className="gradient-box gradient-red text-white">
            <Card.Body>
              <h5>Pending</h5>
              <p style={{ fontSize: "20px" }}>{pending}</p>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="gradient-box gradient-blue text-white">
            <Card.Body>
              <h5>Processing</h5>
              <p style={{ fontSize: "20px" }}>{processing}</p>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="gradient-box gradient-green text-white">
            <Card.Body>
              <h5>Completed</h5>
              <p style={{ fontSize: "20px" }}>{completed}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped my-3 customer-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Title</th>
                {/* <th>Priority</th> */}
                <th>Due Date</th>

                <th>Assigned To</th>
                <th>Assigned By</th>
                {/* <th>Created At</th>
                <th>Updated At</th> */}
                <th>Status</th>
                <th>Sub Task</th>
                <th>Comments</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((task, i) => (
                <tr key={task.task_id}>
                  {/* <td>{indexOfFirstItem + i + 1}</td> */}
                  <td>{filteredTaskList.length - (indexOfFirstItem + i)}</td>
                  <td>{task.task_name}</td>
                  {/* <td>{task.priority}</td> */}
                  <td>{task.due_date}</td>

                  <td>{task.assigned_to_name}</td>
                  <td>{task.assigned_by_name}</td>

                  {/* <td>{task.created_at}</td>
                  <td>{task.updated_at}</td> */}
                  <td>{task.status}</td>
                  <td className="">
                    <Link to={`/subtasklist/${task.task_id}`} >
                      <FaTasks className="view-icon me-2" />
                    </Link>
                  </td>
                  <td className="">
                    <Link to={`/commentlist/${task.task_id}`} >
                      <FaComments className="view-icon me-2" />
                    </Link>
                  </td>
                  <td className="">
                    <Link to={`/viewtask/${task.task_id}`} >
                      <FaEye className="view-icon me-2" />
                    </Link>
                    <Link to={`/edittask/${task.task_id}`}>
                      <FaEdit className="edit-icon me-2" />
                    </Link>
                    <FaTrash
                      className="delete-icon"
                      // onClick={() => handleDelete(task.task_id)}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to delete this?")) {
                          handleDelete(task.task_id);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))}
              {currentItems.length === 0 && (
                <tr>
                  <td colSpan="10" className="text-center">
                    No tasks found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default Task;
